// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"9987e295","392":"f9171454","395":"0649f391","523":"ae1f7b33"}[chunkId] + ".chunk.js";
};